import { Accordion, Box } from "@mantine/core"
import { Icon } from "@iconify/react";
import { Icons } from "src/components/ui/Icons";
import { OperationsAdminVenueBookingCalendarTalentFilter } from "./OperationsAdminVenueBookingCalendarTalentFilter";
import { OperationsAdminVenueBookingCalendarAreaFilter } from "./OperationsAdminVenueBookingCalendarAreaFilter";

export function OperationsAdminVenueBookingCalendarSidebar() {

    return (
        <Box>
            <Accordion
                variant="filled"
                defaultValue={["talent"]}
                multiple
            >
                <Accordion.Item value="talent">
                    <Accordion.Control
                        icon={<Icon icon={Icons.talent} width={22} />}
                    >
                        Filter by Talent
                    </Accordion.Control>
                    <Accordion.Panel>
                        <OperationsAdminVenueBookingCalendarTalentFilter />
                    </Accordion.Panel>
                </Accordion.Item>
                <Accordion.Item value="area">
                    <Accordion.Control
                        icon={<Icon icon={Icons.area} width={22} />}
                    >
                        Filter by Area
                    </Accordion.Control>
                    <Accordion.Panel>
                        <OperationsAdminVenueBookingCalendarAreaFilter/>
                    </Accordion.Panel>
                </Accordion.Item>
            </Accordion>

        </Box>
    )

}